export default __webpack_public_path__ + "static/heroLoop-3be4a81a3ffce8a8e41f2e13519f1463.mp4";